module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/notosanskr/notokr-light.woff2
// module id = QioE
// module chunks = 0